export type createContactAttributeType = {
	internalName?: string;
	targetFields: string[];
	crmColumnName?: string;
	remapRules: {
		initialValues: string[];
		remappedValue: string;
	}[];
	required: boolean;
	id?: string;
};

export type ContactAttributesMapRule = {
	initialValues: string[];
	remappedValue: string;
};

export enum ContactAttributeFormatTypes {
	TEXT = 'text',
	STRING = 'string',
	NUMBER = 'number',
	BOOLEAN = 'boolean',
	DATE = 'date',
	ARRAY = 'array',
	RELATIVE_DATE = 'relativeDate',
	OBJECT = 'object',
}

export type ContactAttributeType = {
	searchCrmColumns: [];
	required?: boolean;
	removeOnBlank?: boolean;
	deleted?: boolean;
	_id: string;
	crmColumnName: string;
	remapRules: ContactAttributesMapRule[];
	workspace: string;
	location: string;
	createdAt: string;
	updatedAt: string;
	id: string;
	format: ContactAttributeFormatTypes;
	targetFields: string[] | string;
	displayName: string;
};

export type ContactAttributeValueType = {
	location: string;
	deleted: boolean;
	_id: string;
	workspace: string;
	audience: string;
	contactAttribute: string;
	value: string;
	createdAt: string;
	updatedAt: string;
	id: string;
};
